// extracted by mini-css-extract-plugin
module.exports = {"Gallery":"Gallery_Gallery__MmMyD","Img1":"Gallery_Img1__tWe6A","Text":"Gallery_Text__bXeDm","Img2":"Gallery_Img2__1BRAM","Img3":"Gallery_Img3__K5USm"};